module.exports = __webpack_public_path__ + "media/Bitfluent-Desktop-Video.c69c7465.mp4";